import React from 'react';
import {
  Card,
  CardContent,
  CardActions,
  Box,
  Typography,
  Chip,
  Divider,
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Visibility as ViewIcon,
  AddTask as AddTaskIcon,
  AccountTree as WorkflowIcon,
} from '@mui/icons-material';
import type { WorkflowCardProps } from './types';

const WorkflowCard: React.FC<WorkflowCardProps> = ({
  workflow,
  onViewDetails,
  onAssignTicket,
  formatDate,
  getStatusColor,
}) => {
  return (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography variant="h6" component="div">
            {workflow.name}
          </Typography>
          <Chip
            label={workflow.status}
            color={getStatusColor(workflow.status)}
            size="small"
          />
        </Box>

        <Box sx={{ mb: 2 }}>
          <Chip
            icon={<WorkflowIcon />}
            label={workflow.kategorie}
            variant="outlined"
            size="small"
            sx={{ mr: 1 }}
          />
        </Box>

        {workflow.beschreibung && (
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            {workflow.beschreibung}
          </Typography>
        )}

        <Divider sx={{ my: 1 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2">
            Schritte: {workflow.anzahlSchritte}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Erstellt: {formatDate(workflow.erstelltAm)}
          </Typography>
        </Box>

        {workflow.abgeschlossenAm && (
          <Typography variant="caption" color="success.main">
            Abgeschlossen: {formatDate(workflow.abgeschlossenAm)}
          </Typography>
        )}
      </CardContent>
      <CardActions>
        <Tooltip title="Details anzeigen">
          <IconButton size="small" onClick={() => onViewDetails(workflow)} color="primary">
            <ViewIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Ticket zuordnen">
          <IconButton size="small" onClick={() => onAssignTicket(workflow)} color="secondary">
            <AddTaskIcon />
          </IconButton>
        </Tooltip>
      </CardActions>
    </Card>
  );
};

export default WorkflowCard;
